export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11132.bb40de18.jpg";